import { ActionType } from 'typesafe-actions'
import { machineErrorsActions, machineErrorsActionType } from './actions'
import { MachineError } from './machine-error'

export interface MachineErrorsState {
  readonly error: Error
  readonly isLoading: boolean
  readonly machineErrors: MachineError[]
  readonly totalCount: number
  readonly currentPage: number
  readonly pageSize: number
}

export const initialState: MachineErrorsState = {
  error: null,
  isLoading: false,
  machineErrors: [],
  totalCount: 0,
  currentPage: 1,
  pageSize: 50,
}

export const machineErrorsReducer = (
  state: MachineErrorsState = initialState,
  action: ActionType<typeof machineErrorsActions>
) => {
  switch (action.type) {
    case machineErrorsActionType.FETCH_MACHINE_ERRORS:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case machineErrorsActionType.FETCH_MACHINE_ERRORS_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        error: null,
        machineErrors: action.payload.machineErrors,
        totalCount: action.payload.totalCount,
      }
    case machineErrorsActionType.THROW_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      }
    case machineErrorsActionType.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload.page,
      }
    default:
      return state
  }
}
